import { Box, Heading, Badge, Gap } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import {
  getBadgeColor,
  getBadgeText,
  getValidationItemHeading,
} from 'sections/design/template-management/sections/template-editor/utils/validation-helpers';
import { ITemplateValidationRule } from 'sections/design/template-management/entities/templates';
import { ValidationItemHeaderLeftElement, ValidationItemHeaderRightElement } from '../../../../style';

interface IProps {
  validationItem: ITemplateValidationRule;
}

export const ValidationItemHeader = ({ validationItem }: IProps) => {
  const { t } = useTranslation('trackingLinks');
  return (
    <Box>
      <ValidationItemHeaderLeftElement>
        <Heading variation="h3">{getValidationItemHeading(validationItem.rule, t)}</Heading>
      </ValidationItemHeaderLeftElement>
      <ValidationItemHeaderRightElement>
        {validationItem.count > 0 ? (
          <Box verticalPositioning="center">
            <Badge color={getBadgeColor(validationItem.severity)}>{getBadgeText(validationItem.severity, t)}</Badge>
            <Gap right={10} />
            <Badge color={getBadgeColor(validationItem.severity)}>{validationItem.count}</Badge>
          </Box>
        ) : (
          <Badge color={getBadgeColor('pass')}>{getBadgeText('pass', t)}</Badge>
        )}
      </ValidationItemHeaderRightElement>
    </Box>
  );
};
